import { render, staticRenderFns } from "./ProvideOrder.vue?vue&type=template&id=6ff734fb&"
import script from "./ProvideOrder.vue?vue&type=script&lang=js&"
export * from "./ProvideOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports